import React, { useEffect } from 'react';
import Table from '../../../../components/table';
import useSetState from '../../../../hooks/useSetState';
import { useDispatch, useSelector } from 'react-redux';
import { purchasePackagesReportListColumns } from '../../../../enums/columns/purchasePackagesReport';
import { getPurchasePackagesReport } from '../../../../redux/financialTransactions/actions';
import PurchasePackagesReportFilter from '../filters/purchasePackagesReportFilter';
import submitForm from '../../../../utils/submitForm';

const PurchasePackagesReportTab = () => {
  const dispatch = useDispatch();

  const [controls, setControls] = useSetState({
    sort: {
      sortType: 'desc',
      sortBy: 'date',
      sortQuery: '',
      filterQuery: '',
    },
    query: '',
    pageNumber: 1,
    pageSize: 10,
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const {
    purchasePackagesReportList,
    getPurchasePackagesReportLoading,
    purchasePackagesReportListTotalRecords,
  } = useSelector(state => ({
    purchasePackagesReportList:
      state.financialTransactionsReducer.purchasePackagesReportList,

    getPurchasePackagesReportLoading:
      state.financialTransactionsReducer.getPurchasePackagesReportLoading,

    purchasePackagesReportListTotalRecords:
      state.financialTransactionsReducer.purchasePackagesReportListTotalRecords,
  }));

  const getPurchasePackagesList = () => {
    const query = `pageNumber=${1}&pageSize=${10}&sort=date-desc`;
    dispatch(getPurchasePackagesReport(query))
      .then(result => {
        console.log(result);
      })
      .catch(error => console.log('error', error));
  };

  const onPageChanged = pageNumber => {
    onChangeValue('pageNumber', pageNumber);
    onChangeValue('pageNumber', pageNumber);
    const query = buildSearchQuery(pageNumber, controls.pageSize);
    dispatch(getPurchasePackagesReport(query));
  };

  const buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&sort=${controls.sort.sortQuery || 'createdAt-desc'}`;
      if (controls.sort.filterQuery) {
        query += '&' + controls.sort.filterQuery;
      }
      return query;
    }
  };

  const sortTable = columnName => {
    const sortType = controls.sort.sortType === 'asc' ? 'desc' : 'asc';
    onChangeValue('sort', { ...controls.sort, sortType, sortBy: columnName });
  };

  const filterAndSort = () => {
    let searchQuery = buildSearchQuery(1, controls.pageSize);
    dispatch(getPurchasePackagesReport(searchQuery));
  };

  const applyFilters = (event, fromDate, toDate) => {
    event.preventDefault();
    const queryString = submitForm(event, fromDate, toDate);
    onChangeValue('sort', { ...controls.sort, filterQuery: queryString });
  };

  const resetForm = () => {
    onChangeValue('pageNumber', 1);
    onChangeValue('sort', { ...controls.sort, filterQuery: '' });
  };

  useEffect(() => {
    const query = `pageNumber=${1}&pageSize=${10}&sort=date-desc`;
    dispatch(getPurchasePackagesReport(query));
  }, []);

  useEffect(() => {
    const sortQuery = `${controls.sort.sortBy}-${controls.sort.sortType}`;
    onChangeValue('sort', { ...controls.sort, sortQuery });
  }, [controls.sort.sortType]);

  useEffect(() => {
    if (controls.sort.sortQuery !== '') {
      onChangeValue('pageNumber', 1);
      filterAndSort();
    }
  }, [controls.sort.sortQuery]);

  useEffect(() => {
    if (controls.sort.filterQuery !== '') {
      onChangeValue('pageNumber', 1);
      filterAndSort();
    }
  }, [controls.sort.filterQuery]);

  return (
    <section>
      <PurchasePackagesReportFilter
        applyFilters={applyFilters}
        getPurchasePackagesList={getPurchasePackagesList}
        resetForm={resetForm}
      />

      <div className='bg-white p-2'>
        <div className='panel-heading'>
          <i className='fas fa-list-alt px-1' />
          {locales('buy.package.report')}
        </div>
        <div className='table-responsive-lg'>
          <Table
            columns={purchasePackagesReportListColumns}
            dataSource={purchasePackagesReportList}
            loading={getPurchasePackagesReportLoading}
            sort={{ type: controls.sortType, action: sortTable }}
            pagination={{
              currentPage: controls.pageNumber,
              pageSize: controls.pageSize,
              totalCount: purchasePackagesReportListTotalRecords,
              onPageChange: onPageChanged,
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default PurchasePackagesReportTab;
